import { call, put, takeLatest, all } from 'redux-saga/effects'
import { stopSubmit } from 'redux-form'

import api from 'core/utils/api'
import * as profile from './actions'
import * as notify from 'components/ui/Notify/store/actions'

export function* fetch(action) {
  try {
    const res = yield call(api.get, '/users/profile')
    yield put(profile.actions.fetchSuccess(res.data.user))
  } catch (err) {
    yield put(profile.actions.fetchFail(err.response.data.error))
  }
}

function* watchFetch() {
  yield takeLatest(profile.actionTypes.fetch, fetch)
}

export function* update(action) {
  try {
    const res = yield call(api.put, `/users/profile`, {user: action.payload})
    yield put(profile.actions.updateSuccess(res.data.user))
    yield put(notify.actions.success('Profile updated.'))
  } catch(err) {
    yield put(profile.actions.updateFail(err.response.data.error))
    yield put(stopSubmit('profileEdit', err.response.data.error.message))
  }
}

function* watchUpdate() {
  yield takeLatest(profile.actionTypes.update, update)
}

export default function* profileSaga() {
  yield all([
    watchFetch(),
    watchUpdate()
  ])
}



// WEBPACK FOOTER //
// ./src/features/Settings/profile/store/sagas.js